import { DataResult, State } from '@progress/kendo-data-query';
import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react';
import { useQuery, UseQueryOptions } from 'react-query';

interface UseGridV2Props {
    transform?: (data: any) => any;
    query: {
        queryKey: any[];
        queryFn: (gridState: State, ...args: any) => Promise<any>;
        queryOptions?: UseQueryOptions<any>;
    };
    gridState: State,
    setGridState:  Dispatch<SetStateAction<State>>
}

const useGridV2 = ({ transform, query: { queryKey, queryFn, queryOptions }, gridState, setGridState  }: UseGridV2Props) => {
    const [gridResult, setGridResult] = useState<DataResult>({
        data: [],
        total: 0,
    });
    const queryFnArgs = typeof queryKey === 'string' ? [] : queryKey.slice(1);
    // Next line => another possible solution
    // const gridQueryKey = typeof queryKey === 'string' ? [queryKey, gridState] : [...queryKey, gridState];
    //@ts-ignore
    const gridQuery = useQuery(queryKey, () => queryFn(gridState, ...queryFnArgs), {
        onSuccess: (data: any[]) => {
            changeGridResult(data || [])
        },
        ...queryOptions,
    });


    useEffect(() => {
        if (gridQuery.data) {
            setGridResult(updateGridResult(gridQuery.data, transform));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gridQuery.data]);

    const changeGridResult = (result: any[] | DataResult) => {
        if (transform !== undefined) {
            setGridResult(updateGridResult(result, transform));
        } else {
            setGridResult(updateGridResult(result));
        }
    };

    return {  gridResult, changeGridResult, gridQuery };
};

export default useGridV2;

const updateGridResult = (result: any[] | DataResult, transform?: (data: any) => any) => {
    if (isDataResult(result))
    {
        return {
            data: transform ? result.data?.map((item) => transform(item)) : result.data,
            total: result.total,
        } as DataResult
    }

    return {
        data: transform ? result.map((item) => transform(item)) : result,
        total: result.length,
    };
};

const isDataResult = (data: any[] | DataResult): data is DataResult => {
    return (data as DataResult).data !== undefined;
}
